export default __webpack_public_path__ + "static/media/ticketSVG.73c6c37b.svg";